import Vue from 'vue'
import './pollyfills'
import VueRouter from 'vue-router'
import VueRouterPrefetch from 'vue-router-prefetch'
import VueNotify from 'vue-notifyjs'
import VeeValidate from 'vee-validate'
import VeeValidateRU from 'vee-validate/dist/locale/ru'
import lang from 'element-ui/lib/locale/lang/ru-RU'
import locale from 'element-ui/lib/locale'
import App from './App.vue'
import GetTextPlugin from 'vue-gettext'
import translations from './translations'
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import store from './store'
import Vue2Crumbs from 'letsnova-vue-2-crumbs'
import _ from 'lodash'
import VueYandexMetrika from 'vue-yandex-metrika'
import VueFragment from 'vue-fragment'

import axiosPlugin from "./axiosPlugin.js";
import authPlugin from './authPlugin';

// Plugins
import GlobalComponents from './globalComponents'
import GlobalDirectives from './globalDirectives'
import SideBar from './components/UIComponents/SidebarPlugin'
import initProgress from './progressbar';

// template router setup
import templateRoutes from './routes/routes'

import appRoutes from 'src/components/Expostat/routes'

import vueDebounce from 'vue-debounce'


// library imports

import './assets/sass/paper-dashboard.scss'
import './assets/sass/demo.scss'
import 'handsontable/dist/handsontable.full.min.css'

import sidebarLinks from './sidebarLinks'
import './registerServiceWorker'
// plugin setup
Vue.use(VueRouter)
Vue.use(VueRouterPrefetch)
Vue.use(GlobalDirectives)
Vue.use(GlobalComponents)
Vue.use(VueNotify)
Vue.use(SideBar, {sidebarLinks: sidebarLinks})
Vue.use(Vue2Crumbs)
Vue.use(vueDebounce)
Vue.use(VueFragment.Plugin)

// Подключение валидатора на русском языке
VeeValidate.Validator.localize('ru', VeeValidateRU)
Vue.use(VeeValidate, {locale: 'ru'})
locale.use(lang)
Vue.use(GetTextPlugin, {
  availableLanguages: {
    en: 'English',
    ru: 'Русский'
  },
  defaultLanguage: 'ru',
  translations: translations,
  silent: process.env.NODE_ENV === 'production'
})

Vue.filter('translate', value => {
  return !value
    ? ''
    : Vue.prototype.$gettext(value.toString())
})

// configure router
// Если режим разработки, то добавляем роуты шаблона
let routes
if (process.env.NODE_ENV === 'development') {
  routes = [
    ...appRoutes,
    ...templateRoutes
  ]
} else {
  routes = [
    ...appRoutes
  ]
}

export const router = new VueRouter({
  mode: 'history',
  routes, // short for routes: routes
  linkActiveClass: 'active',
  scrollBehavior: (to) => {
    if (to.hash) {
      return {selector: to.hash}
    } else {
      return { x: 0, y: 0 }
    }
  }
})

initProgress(router);


Vue.use(axiosPlugin)

Vue.router = router
App.router = Vue.router

Vue.use(authPlugin)

// Vue.use(require('vue-moment'));

const moment = require('moment')
require('moment/locale/ru')

Vue.use(require('vue-moment'), {
  moment
})

// if (process.env.NODE_ENV === 'production') {
//   Raven
//     .config('https://979f89f494204399bc847bb7ac7d2bf3@sentry.io/1265738')
//     .addPlugin(RavenVue, Vue)
//     .install();
// }

Vue.use(VueYandexMetrika, {
  id: 54135262,
  router: router,
  env: process.env.NODE_ENV,
  scriptSrc: 'https://mc.yandex.ru/metrika/tag.js',
  options: {
    clickmap:true,
    trackLinks:true,
    accurateTrackBounce:true,
    webvisor:true,
    trackHash:true
  }
})

/* eslint-disable no-new */
export default new Vue({
  el: '#app',
  render: h => h(App),
  data () {
    return {
      eventInfo: {
        name: null
      }
    }
  },
  computed: {
    expoStatPermissions () {
      return {
        stands: this.$auth.user().permissions.stands.reduce((obj, item) => {
          obj[item.stand] = item.role
          return obj
        }, {})
      }
    }
  },
  methods: {
  },
  store
})
